import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-700 fs-6 mb-8" }, " Bu Gizlilik Politikası, TekPanel uygulaması ve panel.mays.app üzerinden sunulan hizmetleri kullandığınızda kişisel verilerinizin nasıl toplandığını, kullanıldığını ve korunduğunu açıklar. Hizmeti kullanarak bu politikayı kabul etmiş sayılırsınız. ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold text-dark mb-3" }, "1. Veri Sorumlusu", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-700 fs-6 mb-8" }, [
  /*#__PURE__*/_createTextVNode(" Kişisel verileriniz, veri sorumlusu sıfatıyla YYVZ LLC tarafından işlenmektedir. İletişim: "),
  /*#__PURE__*/_createElementVNode("strong", null, "hello ( at ) mays.app")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold text-dark mb-3" }, "2. Topladığımız Veriler", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("ul", { class: "text-gray-700 fs-6 mb-8" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Hesap bilgileri:"),
    /*#__PURE__*/_createTextVNode(" Telefon numarası ve giriş için kullanılan kimlik bilgileri. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "İşletme ve entegrasyon bilgileri:"),
    /*#__PURE__*/_createTextVNode(" Bağladığınız sipariş platformlarının (Yemeksepeti, Getir, Trendyol Yemek, Migros Yemek) hesap bağlantı bilgileri ile işletmenize ait ad, adres, telefon ve e-posta gibi bilgiler. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Kullanım kayıtları:"),
    /*#__PURE__*/_createTextVNode(" Uygulama içinde yaptığınız ürün açma/kapama, fiyat güncelleme ve yorum cevaplama gibi işlemlerin kayıtları. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Cihaz ve bildirim bilgileri:"),
    /*#__PURE__*/_createTextVNode(" Anlık bildirim gönderimi için cihaz bildirim anahtarı (push token). ")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold text-dark mb-3" }, "3. Verilerin İşlenme Amaçları", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("ul", { class: "text-gray-700 fs-6 mb-8" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, "Hizmetin sunulması ve hesabınızın yönetilmesi,"),
  /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, " Bağlı platformlarda ürün, fiyat ve mağaza durumu işlemlerinin gerçekleştirilmesi, "),
  /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, " Otomatik/zamanlanmış işlemler ve ilgili bildirimlerin gönderilmesi, "),
  /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, "Güvenlik, hata giderme ve hizmet kalitesinin artırılması.")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold text-dark mb-3" }, "4. Üçüncü Taraflarla Paylaşım", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-700 fs-6 mb-3" }, " Verileriniz, yalnızca hizmetin gerektirdiği ölçüde aşağıdaki taraflarla paylaşılır: ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("ul", { class: "text-gray-700 fs-6 mb-8" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Sipariş platformları:"),
    /*#__PURE__*/_createTextVNode(" Sizin adınıza işlem yapabilmek için ilgili platformların resmi API'leri. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Bildirim altyapısı:"),
    /*#__PURE__*/_createTextVNode(" Anlık bildirimler için Google Firebase Cloud Messaging. ")
  ])
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-700 fs-6 mb-8" }, " Kişisel verileriniz pazarlama amacıyla üçüncü taraflara satılmaz veya kiralanmaz. ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold text-dark mb-3" }, "5. Veri Saklama ve Güvenlik", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-700 fs-6 mb-8" }, " Verileriniz, hizmetin sunulması için gerekli olduğu süre boyunca ve yasal yükümlülükler çerçevesinde saklanır. Verilerinizin yetkisiz erişime karşı korunması için uygun teknik ve idari tedbirler uygulanır. ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold text-dark mb-3" }, "6. Haklarınız", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-700 fs-6 mb-3" }, [
  /*#__PURE__*/_createTextVNode(" KVKK kapsamında; kişisel verilerinizin işlenip işlenmediğini öğrenme, bunlara erişme, düzeltilmesini veya silinmesini talep etme haklarına sahipsiniz. Hesabınızın ve verilerinizin silinmesini talep etmek için "),
  /*#__PURE__*/_createElementVNode("strong", null, "hello ( at ) mays.app"),
  /*#__PURE__*/_createTextVNode(" adresinden bize ulaşabilirsiniz. ")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold text-dark mb-3" }, "7. Değişiklikler", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-700 fs-6 mb-8" }, " Bu politika zaman zaman güncellenebilir. Güncel sürüm her zaman bu sayfada yayınlanır. ", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold text-dark mb-3" }, "8. İletişim", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-700 fs-6 mb-0" }, [
  /*#__PURE__*/_createTextVNode(" Gizlilik ile ilgili sorularınız için: "),
  /*#__PURE__*/_createElementVNode("strong", null, "hello ( at ) mays.app")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PublicPage = _resolveComponent("PublicPage")!

  return (_openBlock(), _createBlock(_component_PublicPage, {
    title: "Gizlilik Politikası",
    subtitle: "Son güncelleme: 25 Mayıs 2026"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      _hoisted_10,
      _hoisted_11,
      _hoisted_12,
      _hoisted_13,
      _hoisted_14,
      _hoisted_15,
      _hoisted_16,
      _hoisted_17,
      _hoisted_18,
      _hoisted_19
    ]),
    _: 1
  }))
}